var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signin-main"},[_c('div',{staticClass:"signin-container"},[_c('div',{staticClass:"signin-hold"},[_c('h1',{staticClass:"green-text",domProps:{"innerHTML":_vm._s(_vm.urlmsg)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }